export const subtitles = {
    "1": {
        "startTime": 1.96,
        "endTime": 5.51,
        "transcript": "Cunaw' atellgutkekemken.",
        "translation": "Turns out, we have the same name."
    },
    "2": {
        "startTime": 7.01,
        "endTime": 9.37,
        "transcript": "Qalarrluteng test-arluku.",
        "translation": "Please speak to test it."
    },
    "3": {
        "startTime": 9.375,
        "endTime": 10.845,
        "transcript": "Yaa, tua-llu?",
        "translation": "Okay, can you hear me?"
    },
    "4": {
        "startTime": 10.845,
        "endTime": 11.92,
        "transcript": "Qalarrluten cali.",
        "translation": "Speak more."
    },
    "5": {
        "startTime": 11.92,
        "endTime": 12.78,
        "transcript": "Qaillun?",
        "translation": "How?"
    },
    "6": {
        "startTime": 12.785,
        "endTime": 13.685,
        "transcript": "Piciatun.",
        "translation": "Any way."
    },
    "7": {
        "startTime": 14.54,
        "endTime": 15.73,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "8": {
        "startTime": 18.09,
        "endTime": 21.08,
        "transcript": "Quseryukataryugnarqua wii.",
        "translation": "I think I'm going to be coughing."
    },
    "9": {
        "startTime": 22.18,
        "endTime": 23.95,
        "transcript": "Kitak' ayagnia.",
        "translation": "Now, start."
    },
    "10": {
        "startTime": 24.3,
        "endTime": 27.64,
        "transcript": "Qaill' ellangellerpeni umyuaqsiu?",
        "translation": "What do you remember in your earliest memories?"
    },
    "11": {
        "startTime": 28.305,
        "endTime": 37.94,
        "transcript": "Yaa, ellangellemni wani ellangellruunga un'gani Tagyaram iluani.",
        "translation": "Okay, growing up, my earliest memories are of downriver in Tagyaraq."
    },
    "12": {
        "startTime": 37.94,
        "endTime": 39.92,
        "transcript": "Tauna naanguaqsaagaa.",
        "translation": "(S)he's trying ot play with that."
    },
    "13": {
        "startTime": 42.365,
        "endTime": 47.875,
        "transcript": "Tauna naanguaqevkenaku. Atam [?]... hey!",
        "translation": "Don'y play with that. Look [?]... hey!"
    },
    "14": {
        "startTime": 48.915,
        "endTime": 53.105,
        "transcript": "Yaa, ellangellemni ellangellruunga Tagyaram iluani.",
        "translation": "Yes, growing up, my earliest memories are in Tagyaraq."
    },
    "15": {
        "startTime": 54.555,
        "endTime": 58.645,
        "transcript": "Aterluni tauna nunallerput Quunermek.",
        "translation": "Our old village there was called Quuneq."
    },
    "16": {
        "startTime": 62.765,
        "endTime": 65.055,
        "transcript": "Quunermek.",
        "translation": "[It was called] Quuneq."
    },
    "17": {
        "startTime": 65.755,
        "endTime": 73.885,
        "transcript": "Ellangarteqarraallemni wani im'ullruunga",
        "translation": "In my earliest memores, I, you know"
    },
    "18": {
        "startTime": 75.015,
        "endTime": 77.645,
        "transcript": "Kiimecukelallruukut.",
        "translation": "We used to think we were alone."
    },
    "19": {
        "startTime": 77.645,
        "endTime": 81.18,
        "transcript": "Ellamun-llu mom-ama anevkarqanga",
        "translation": "And when my mom had me go outside"
    },
    "20": {
        "startTime": 81.18,
        "endTime": 87.45,
        "transcript": "Tua-i kiarrnaurtua, tuar tang maani avatemteńun ella pimalalria.",
        "translation": "I would look around, and it would seem that the world extended to our vicinity."
    },
    "21": {
        "startTime": 87.45,
        "endTime": 94.62,
        "transcript": "Iciw' kiimeta tuar tang yuuluta. Umyuarteqaqlua-llu kiimeta yuuyukluta.",
        "translation": "You know, it seemed like we were the only people. And I would think we were the only people."
    },
    "22": {
        "startTime": 94.89,
        "endTime": 104.21,
        "transcript": "Ukut-llu angiinka tekitnaurtut yuilqumek tuar. Wangni yuilqumek tekicukaqluki.",
        "translation": "And my older brothers would arrive seemingly from the wilderness. I thought they came from the wilderness."
    },
    "23": {
        "startTime": 104.21,
        "endTime": 108.81,
        "transcript": "Nunapiamteńek cunaw' Qinarmek tekitelallinilriit.",
        "translation": "Apparently, they'd come from our home village, Qinaq."
    },
    "24": {
        "startTime": 108.81,
        "endTime": 114.77,
        "transcript": "Tuamtell' aataka wani ayagnaurtuq.",
        "translation": "Then my mother would travel."
    },
    "25": {
        "startTime": 114.93,
        "endTime": 121.04,
        "transcript": "Tekiutnaurtuq canek Kass'artarnek-wa tua-i kipukengaminek.",
        "translation": "He would bring back Western things he had purchased."
    },
    "26": {
        "startTime": 121.04,
        "endTime": 133.08,
        "transcript": "Cunaw' Ciutmi call' uani cali Tagyaram iluani taumek ilura'urluminek kipusvigtelallrullinill'.",
        "translation": "Apparently, he would go to the store owned by his male cross-cousin there in Ciun, also in Tagyaraq."
    },
    "27": {
        "startTime": 133.08,
        "endTime": 136.51,
        "transcript": "Caaqami cali ayalallruuq.",
        "translation": "Some days, he would go."
    },
    "28": {
        "startTime": 136.61,
        "endTime": 141.63,
        "transcript": "Maligcugyaaqaqamni yaaqvanun piqatarniaqluni.",
        "translation": "When I wanted to go with him, he'd say that was going to go far away."
    },
    "29": {
        "startTime": 141.63,
        "endTime": 146.09,
        "transcript": "Tua-i-ll' apcamni Ekvicuarmiunun ayakatarniluni.",
        "translation": "Then when I asked him, he'd say he was going to go to Eek."
    },
    "30": {
        "startTime": 146.09,
        "endTime": 154.67,
        "transcript": "It turned out, what did they call their resident Caucasian in Eek again?",
        "translation": "It turned out, what did they call their resident Caucasian in Eek again?"
    },
    "31": {
        "startTime": 154.67,
        "endTime": 157.94,
        "transcript": "Tuavet cali Kass'artelalliniluni.",
        "translation": "He'd also buy Western things from there."
    },
    "32": {
        "startTime": 157.94,
        "endTime": 168.04,
        "transcript": "Tua-ll' murilkenglua, maligtelangluku-llu aataka.",
        "translation": "Then I became observant, and started going with my father."
    },
    "33": {
        "startTime": 169.2,
        "endTime": 179.14,
        "transcript": "Tua-i tuavet wani Ciutmun ilura'urluanun Kass'artaqlunuk. Tua-i kiingan taumun maliketulua caqa'arqami.",
        "translation": "We would go buy western things there in Ciun from his cousin. I would only go with him there, sometimes."
    },
    "34": {
        "startTime": 179.39,
        "endTime": 186.12,
        "transcript": "Yugnun maliksuitellruanga. Tua-i nacikangramnia maliksuunii, yuilqurrlainarmun tau͡gaam",
        "translation": "He didn't bring me with him to other people. He wouldn't take me though I was sad over his departure, only [took me] to the wilderness."
    },
    "35": {
        "startTime": 192.61,
        "endTime": 199.21,
        "transcript": "Tua-i-ll' murilkengama nalluyagucuirullua.",
        "translation": "Then when I became observant, I had permanent long term memory."
    },
    "36": {
        "startTime": 199.21,
        "endTime": 206.7,
        "transcript": "Cali ukut neqlilput Cuuvalegmiut, cali taum tua-i nunakelallemta uakariini",
        "translation": "And our fishcamp in Cuukvalegmiut, also right downriver from our old settlement"
    },
    "37": {
        "startTime": 206.7,
        "endTime": 211.88,
        "transcript": "Taukut cali tua-i tuaten ayuquryukaqluki, kiaguuryuki-llu.",
        "translation": "I also thought that place was always like that, and was in eternal summer."
    },
    "38": {
        "startTime": 212.15,
        "endTime": 217.0,
        "transcript": "Umyuartequtaqluki tuaten, kiaguuratuyukluki.",
        "translation": "I thought of them like that, that it was always summer there."
    },
    "39": {
        "startTime": 217.0,
        "endTime": 219.94,
        "transcript": "Tuantaqluteng amllerrluteng taukut.",
        "translation": "There would be many staying there."
    },
    "40": {
        "startTime": 219.94,
        "endTime": 227.92,
        "transcript": "Aya'agqata-ll' tang tau͡gken umyuaqngateksaunaki-llu upa'agqamta.",
        "translation": "And I don't think I remembered them when they left, when we moved."
    },
    "41": {
        "startTime": 229.8,
        "endTime": 234.41,
        "transcript": "Tua-i-ll' murilkenglua tua-i.",
        "translation": "Then I became observant."
    },
    "42": {
        "startTime": 235.68,
        "endTime": 238.64,
        "transcript": "Itrarluta-llu.",
        "translation": "And we went upriver."
    },
    "43": {
        "startTime": 241.27,
        "endTime": 245.97,
        "transcript": "Tamaani-wa kinguqlinglallruyaaqellriakuk wangkuk.",
        "translation": "Back then, the two of us would get younger siblings."
    },
    "44": {
        "startTime": 246.83,
        "endTime": 251.92,
        "transcript": "Ugna-llu tungkeqerlunuk yuumallruukuk kiirramegnuk.",
        "translation": "[My sibling] downriver and I lived as lone [siblings] for a long time."
    },
    "45": {
        "startTime": 251.92,
        "endTime": 261.7,
        "transcript": "Tua-i-ll' au͡g'umek Qinarmun itranemteggun kinguqlinglunuk.",
        "translation": "Then right when we went upriver to Qinaq, we got a younger siblings."
    },
    "46": {
        "startTime": 261.7,
        "endTime": 267.13,
        "transcript": "Qurrelvagmun uksuiyaturiluta im'ungluta",
        "translation": "When we'd started going to winter camp in Qurrelvak, we, you know"
    },
    "47": {
        "startTime": 267.13,
        "endTime": 271.37,
        "transcript": "Taumek ug'umek wani kinguqlinglunuk.",
        "translation": "We got a younger sibling, the one downriver."
    },
    "48": {
        "startTime": 271.37,
        "endTime": 276.42,
        "transcript": "Tua-i-ll' tua-i tayima.",
        "translation": "Then that's how it went."
    },
    "49": {
        "startTime": 277.05,
        "endTime": 281.51,
        "transcript": "Tua-i-ll' imkulua",
        "translation": "Then I, you know"
    },
    "50": {
        "startTime": 282.41,
        "endTime": 290.78,
        "transcript": "Qukaqlircarametaqluta, cali tuani itrallemteńi Qurrelvagmun uksuillemteńun tag'aqluta.",
        "translation": "We'd be in Qukaqlircaraq, and when we went upriver then, we would go inland to our winter camp, Qurrelvak."
    },
    "51": {
        "startTime": 293.18,
        "endTime": 296.65,
        "transcript": "Tau͡gaam elitnaurvingan 19...",
        "translation": "But when a school was built in 19..."
    },
    "52": {
        "startTime": 297.61,
        "endTime": 305.09,
        "transcript": "Elitnaungarcata 1951-aami uani Tuntutuliarmi",
        "translation": "When thye started going to school in 1951 downriver at Tuntutuliak"
    },
    "53": {
        "startTime": 305.92,
        "endTime": 310.81,
        "transcript": "Ayayuirutellruukut tamaaken ayagluta.",
        "translation": "We stopped being nomadic ever since then."
    },
    "54": {
        "startTime": 311.82,
        "endTime": 316.57,
        "transcript": "Tau͡gaam-llu tamaa-i wani qanrucimalallruukuk-llu tua-i",
        "translation": "But we would also be told"
    },
    "55": {
        "startTime": 316.57,
        "endTime": 320.77,
        "transcript": "Waten-llu alerqulallruakuk aatamegnuk:",
        "translation": "And our father used to instruct us like this:"
    },
    "56": {
        "startTime": 320.95,
        "endTime": 330.38,
        "transcript": "\"Carangllut-gguq enem iluani carrirturluki. Carrirturluki-gguq cat tamalkuita, natret.",
        "translation": "\"Always clean off debris in the house. Clean everything, the floors."
    },
    "57": {
        "startTime": 331.9,
        "endTime": 335.82,
        "transcript": "\"Cat-llu pellernarqengraata ciqirqelluki.\"",
        "translation": "\"And though things feel gross, dump them out.\""
    },
    "58": {
        "startTime": 335.82,
        "endTime": 341.24,
        "transcript": "Umyuartequlluki-llu-gguq ciqitaqluki",
        "translation": "He also said to think as we dumped them"
    },
    "59": {
        "startTime": 341.24,
        "endTime": 348.79,
        "transcript": "Picuyuglunuk, wall' unguvamayuglunuk, wall'u assirlunuk yuuyuglunuk naulluuyuunanuk.",
        "translation": "That we want to be good hunter-gatherers, or live long, or live well without getting sick."
    },
    "60": {
        "startTime": 348.79,
        "endTime": 355.61,
        "transcript": "Wall'u kenirmigluki-llu-gguq anutaqluki caarrlut.",
        "translation": "Or, he also said to put the debris in our front flounces and take them out."
    },
    "61": {
        "startTime": 355.61,
        "endTime": 362.33,
        "transcript": "Waten piluki wavet kenimun piluki anutaqluki-llu.",
        "translation": "He said to pu tthem here in the front flounce, and take them out."
    },
    "62": {
        "startTime": 363.5,
        "endTime": 370.21,
        "transcript": "Atam-gguq tamaani yuut wani tanqingqerrsulriit",
        "translation": "Look, he said, back then, the people who wanted to have light"
    },
    "63": {
        "startTime": 370.87,
        "endTime": 376.33,
        "transcript": "Tanqingqerrsulriit clean up-aarturluteng tamakut pitullrulliniut",
        "translation": "Those ones who wanted to have light would always clean up"
    },
    "64": {
        "startTime": 376.33,
        "endTime": 379.74,
        "transcript": "Tuaten essuiculriit-gguq.",
        "translation": "The ones he said wanted to be spiritually pure."
    },
    "65": {
        "startTime": 381.37,
        "endTime": 392.71,
        "transcript": "Ilait-gguq tua-i tuaten piuratulrit, naulluuyuunateng-llu-gguq tamakut yuut.",
        "translation": "He said that osme of those who always did that, those people wouldn't get sick."
    },
    "66": {
        "startTime": 394.86,
        "endTime": 407.64,
        "transcript": "And on their hems, he said that though they weren't baptized, they'd emit light from their hems, and the tips of their sleeves, and here from their neck openings.",
        "translation": "And on their hems, he said that though they weren't baptized, they'd emit light from their hems, and the tips of their sleeves, and here from their neck openings."
    },
    "67": {
        "startTime": 408.25,
        "endTime": 416.0,
        "transcript": "Waten tanqigmek anllungaqluteng. Tarrarteng'e'rmeng-llu ellami tan'gerciyuunateng.",
        "translation": "They'd emit light like this. And though they walked around outside, it wouldn't be too dark for them."
    },
    "68": {
        "startTime": 416.0,
        "endTime": 418.85,
        "transcript": "Tamaa-i tuaten qanrutetullruakuk.",
        "translation": "That's what he used to tell us."
    },
    "69": {
        "startTime": 418.85,
        "endTime": 426.11,
        "transcript": "Tamakut-ll' angllumanrilnguuyaaqluteng, nalluvkenateng tamaa-i.",
        "translation": "And those people weren't baptized, but they knew."
    },
    "70": {
        "startTime": 426.11,
        "endTime": 434.7,
        "transcript": "Tuamtellu-gguq naulluulriit pelqevkenaki uqlautekengramteki kenugtelarlaput.",
        "translation": "Then he said that we shouldn't be averse to the sick, but help clean them up though we get dirty."
    },
    "71": {
        "startTime": 434.7,
        "endTime": 440.94,
        "transcript": "Tamaa-i-gguq carrluk-gguq yugnun agtuucuituq.",
        "translation": "He said that impurities do not affect people."
    },
    "72": {
        "startTime": 440.94,
        "endTime": 444.87,
        "transcript": "Menuurcuituq-gguq yuk kevgiulria.",
        "translation": "He said that a person who serves does not become impure."
    },
    "73": {
        "startTime": 446.55,
        "endTime": 458.78,
        "transcript": "Tau͡gaam naulluulangraata-llu ilani naulluungaitetulliniluni.",
        "translation": "But even though those around him are sick, (s)he will not get sick."
    },
    "74": {
        "startTime": 458.78,
        "endTime": 460.41,
        "transcript": "Tamaa-i tang.",
        "translation": "There you have it."
    },
    "75": {
        "startTime": 460.41,
        "endTime": 468.21,
        "transcript": "Tuamtell' wani kevgiurturalriit",
        "translation": "Then, those who serve"
    },
    "76": {
        "startTime": 468.21,
        "endTime": 476.37,
        "transcript": "Iciw' tamakut-llu qeciit carrirluki uqlautek'nge'rmegteki",
        "translation": "You know, cleaning skins though they get dirty"
    },
    "77": {
        "startTime": 478.05,
        "endTime": 485.58,
        "transcript": "Erurilriani-gguq au͡ga'atuut, tau͡gaam-gguq yugmun nepcuitut.",
        "translation": "He said they come off with washing, but they don't stick to a person."
    },
    "78": {
        "startTime": 488.89,
        "endTime": 490.92,
        "transcript": "Tua-i wani...",
        "translation": "Well..."
    },
    "79": {
        "startTime": 490.92,
        "endTime": 496.92,
        "transcript": "Tuamtell' cali makut qantat wani",
        "translation": "Then these bowls"
    },
    "80": {
        "startTime": 496.92,
        "endTime": 501.15,
        "transcript": "Makut wani qantat iciw' erurturluki cat.",
        "translation": "These bowls, you know, always wash things."
    },
    "81": {
        "startTime": 501.15,
        "endTime": 508.55,
        "transcript": "Neqallret-llu tutmallermun pinrilcaarturluki pitullrulliniluteng.",
        "translation": "They would also always discard food scraps where they wouldn't be tread upon."
    },
    "82": {
        "startTime": 511.99,
        "endTime": 522.41,
        "transcript": "Tua-i-ll' cali wani amlleq qanruyun nalluyagutarput maa-i tamalkumta.",
        "translation": "Also, all of us are forgetting much traditional wisdom."
    },
    "83": {
        "startTime": 522.41,
        "endTime": 532.47,
        "transcript": "Wangkuta-llu, Yuulriani wangkuta qanruyutet Yup'igtaat nalluyagulluki.",
        "translation": "And we, we Yupiit, have forgotten the traditional Yup'ik wisdom."
    },
    "84": {
        "startTime": 533.19,
        "endTime": 535.01,
        "transcript": "We've forgotten them.",
        "translation": "We've forgotten them."
    },
    "85": {
        "startTime": 535.01,
        "endTime": 542.92,
        "transcript": "Tuamtell' cali waten wani",
        "translation": "Then like this"
    },
    "86": {
        "startTime": 543.18,
        "endTime": 550.69,
        "transcript": "Ava-i, icivaq cali Naparyarrarmiumek qalartellriamek niitellrulrianga.",
        "translation": "Recently, I also heard someone from Napakiak speaking."
    },
    "87": {
        "startTime": 552.19,
        "endTime": 558.53,
        "transcript": "Wiinga-llu eneqerluki, qanruyutek'lalqa-llu eneqerluku waten:",
        "translation": "And I remembered the traditional wisdom passed down to me like this:"
    },
    "88": {
        "startTime": 558.77,
        "endTime": 562.92,
        "transcript": "Eneqaqercetaarluku, eneqaqercetaarluki-gguq.",
        "translation": "Try to have that person remember, try to have them remember."
    },
    "89": {
        "startTime": 562.92,
        "endTime": 565.26,
        "transcript": "Waten-llu aatama qanrut'lallruakuk:",
        "translation": "My father also used to tell us this:"
    },
    "90": {
        "startTime": 565.26,
        "endTime": 570.73,
        "transcript": "\"Eneqaqercetaarluki-gguq nallunringraitki qanruquratuit.\"",
        "translation": "\"Though they know them, they always tell them to have them remember.\""
    },
    "91": {
        "startTime": 570.73,
        "endTime": 584.16,
        "transcript": "Taumek-gguq qanruyutnek qanrutestemteńek-llu taqsuqeksaunata, tau͡gaam niicugniaqluki qanrit murilkelluki tangvagluki piarkaulliniluta.",
        "translation": "That's why he said we should never tire of traditional wisdom or our instructors, but we must listen to them, watching their mouths."
    },
    "92": {
        "startTime": 587.99,
        "endTime": 595.46,
        "transcript": "Waten-llu qanrut'lallrukiitnga wiinga tua-i assiiturluama",
        "translation": "They also used to tell me this, because I was woefully bad"
    },
    "93": {
        "startTime": 596.86,
        "endTime": 603.75,
        "transcript": "Assiiturluama pilaqiitnga cunaw' qanruyutmek",
        "translation": "Since I was woefully bad, they would tell me what was apparently traditional wisdom"
    },
    "94": {
        "startTime": 605.22,
        "endTime": 609.57,
        "transcript": "\"Yuk-gguq qaskukegcipiatuuq.\"",
        "translation": "\"A person has a very good appearance.\""
    },
    "95": {
        "startTime": 610.25,
        "endTime": 614.49,
        "transcript": "Murak-ll' ava-i imna Naparyarrarmium taum qanrutkellra.",
        "translation": "And wood, what that person from Napakiak was talking about."
    },
    "96": {
        "startTime": 614.49,
        "endTime": 618.59,
        "transcript": "Murak kiinga ciknayaramun atuuvkenani cali.",
        "translation": "Wood is not only used for jealousy."
    },
    "97": {
        "startTime": 619.62,
        "endTime": 628.63,
        "transcript": "Yuk-gguq qaskukegcipiatuuq, assirluni tangellra tangniqluni, apqevceńek cute-arluni.",
        "translation": "He said that a person has a very good appearance, very nice to look, cute as you call it."
    },
    "98": {
        "startTime": 629.27,
        "endTime": 636.4,
        "transcript": "Tau͡gken-gguq tuamtellu-gguq murak angutem tekiciiqaa, murakegtaar.",
        "translation": "However, he said that a man may come upong a great [looking] piece of wood."
    },
    "99": {
        "startTime": 636.4,
        "endTime": 640.92,
        "transcript": "\"Cakneq-lli-gguq equgcigpaa.\"",
        "translation": "\"What a great piece of wood.\""
    },
    "100": {
        "startTime": 640.92,
        "endTime": 647.97,
        "transcript": "Equgcilria-gguq tamana qupciqaa, ilua qipepiarluni.",
        "translation": "He said he will split that good piece of wood, and the inside will be all twisted."
    },
    "101": {
        "startTime": 648.15,
        "endTime": 658.48,
        "transcript": "Tua-i-gguq yuk tuaten, wangkuta-gguq yugni tamalkumta tuaten umyuarput assiiculria tuaten ayuquq.",
        "translation": "He said that a person, all of us people with bad minds are like that."
    },
    "102": {
        "startTime": 658.87,
        "endTime": 667.19,
        "transcript": "Tuamtell' cali angutnguli wall' arnauluni tuaten ayuqluni.",
        "translation": "Also, a man or a woman is like that."
    },
    "103": {
        "startTime": 667.19,
        "endTime": 677.24,
        "transcript": "Tuamtell' cali muragmek-gguq tekiciiquq qipepiamek, murak qipluni.",
        "translation": "Then he said one may come across a very twisted piece of wood, the wood all twisted."
    },
    "104": {
        "startTime": 677.24,
        "endTime": 680.23,
        "transcript": "Tua-i-llu-gguq eqgciatepiarluni tangellra.",
        "translation": "He said it looks like a bad piece of wood."
    },
    "105": {
        "startTime": 680.23,
        "endTime": 692.5,
        "transcript": "Tua-llu-gguq qupsaagluku qupciqaa, elatii kiimi man'a qaskua qipluni, ilua nalqipiarluni aspiarluni.",
        "translation": "Then he said one will try to split it open to find that only the outside is twisted, and the inside is good and straight."
    },
    "106": {
        "startTime": 692.71,
        "endTime": 700.49,
        "transcript": "Ikiunge'rmi-gguq yuk, kegginarrliq'nge'rmi, tuaten qipellriacetun ayuqeng'e'rmi",
        "translation": "He said that though a person is ugly, has an ugly face, and is like that twisted piece of wood"
    },
    "107": {
        "startTime": 700.49,
        "endTime": 712.16,
        "transcript": "Umyuaqegcikuni, umyuaqegcikuni-gguq tuaten ayuquq muragtun qipellriatun, ilua nalqigluni, ilukegcipiarluni.",
        "translation": "He said that if (s)he has a good mind, they are like that twisted piece of wood with the straight grained inside, very good on the inside."
    },
    "108": {
        "startTime": 712.16,
        "endTime": 720.36,
        "transcript": "Tuamtell' aspiarluni tangellra, straight-arluni murak equgcigciqnganani",
        "translation": "Then a straight piece of wood looks good, like it'll be a good piece of wood"
    },
    "109": {
        "startTime": 720.36,
        "endTime": 726.29,
        "transcript": "Qupsaagluku-gguq qupciqaat ilua qipepiarluni.",
        "translation": "He said they'd try to split it open, and the inside would be all twisted."
    },
    "110": {
        "startTime": 726.29,
        "endTime": 730.14,
        "transcript": "Tua-i-gguq cali tuaten yuk ayuquq.",
        "translation": "He said that's what a person is also like."
    },
    "111": {
        "startTime": 730.14,
        "endTime": 737.15,
        "transcript": "Kenegnang'e'rmi, kegginaqegcing'e'rmi, assinge'rmi, wall'u waten assirngalnge'rmi",
        "translation": "Though they look lovely, have a good face, [acts] good, or seems good like this"
    },
    "112": {
        "startTime": 737.38,
        "endTime": 743.84,
        "transcript": "Ilua-gguq tuaten ayuquq yuk umyuarrliqellria.",
        "translation": "He said that the inside of a person with a bad mind is like that."
    },
    "113": {
        "startTime": 745.0,
        "endTime": 747.18,
        "transcript": "Taumek wani",
        "translation": "Because of that"
    },
    "114": {
        "startTime": 751.46,
        "endTime": 755.78,
        "transcript": "Maa-i makut umyuaqelararkaput.",
        "translation": "These are things we must remember."
    },
    "115": {
        "startTime": 755.78,
        "endTime": 761.48,
        "transcript": "Waten-llu yuut assiilkurluki-llu piksaunki.",
        "translation": "Also, do not treat people badly."
    },
    "116": {
        "startTime": 761.74,
        "endTime": 768.97,
        "transcript": "Ayuqenritut, umyugait-llu ayuqenritut tuaten tautun muragtun.",
        "translation": "They're different, and their minds are different like that piece of wood."
    },
    "117": {
        "startTime": 768.97,
        "endTime": 773.04,
        "transcript": "Muragcetun wangkuta ayuqelliniukut yugni.",
        "translation": "Apparently, we people are like wood."
    },
    "118": {
        "startTime": 773.04,
        "endTime": 776.44,
        "transcript": "Wiinga-llu tuaten qanrucimalallruunga.",
        "translation": "I was also told that."
    },
    "119": {
        "startTime": 776.44,
        "endTime": 784.53,
        "transcript": "Qiperrlugluama tua-i ikiungama qanruyutnek niitelallruunga.",
        "translation": "Since I was pitifully twisted and bad, I would hear traditional wisdom."
    },
    "120": {
        "startTime": 784.53,
        "endTime": 788.96,
        "transcript": "Tua-i-ll' tuaten, tuaten-llam qanrutaqatnga-llu",
        "translation": "Then when they would tell me that"
    },
    "121": {
        "startTime": 790.55,
        "endTime": 795.86,
        "transcript": "Ap'artelalrianga-llu iliini, \"Ciin? Ciin tuaten ayuqluni?\"",
        "translation": "I would sometimes ask, \"Why? Why is one like that?\""
    },
    "122": {
        "startTime": 795.86,
        "endTime": 799.94,
        "transcript": "Tua-i-gguq yuk tuaten ayuquq.",
        "translation": "They said a person is like that."
    },
    "123": {
        "startTime": 799.94,
        "endTime": 804.93,
        "transcript": "Qaskukegcilria-gguq tuaten straight-arnganani, ilua qipluni.",
        "translation": "They said one with a good appearance looking straight, has twisted insides."
    },
    "124": {
        "startTime": 805.12,
        "endTime": 807.29,
        "transcript": "Tamalkurmeng tuaten",
        "translation": "All of them like that"
    },
    "125": {
        "startTime": 809.14,
        "endTime": 820.58,
        "transcript": "Assiitellriit, assilriit-llu tuaten tua-i elatait qipngalnge'rmeng, ilukegciluteng umyuaqegciluteng pitulliniluteng.",
        "translation": "The ones [who look] good, and the ones who look bad though their appearances look twisted, have good insides when they have good minds."
    },
    "126": {
        "startTime": 821.96,
        "endTime": 827.31,
        "transcript": "Tamaa-i tamakut umyuaqnarqelaryaaqaput makut.",
        "translation": "Those are the things we must remember."
    },
    "127": {
        "startTime": 827.96,
        "endTime": 830.42,
        "transcript": "Tua-i cali wani",
        "translation": "Also"
    },
    "128": {
        "startTime": 832.9,
        "endTime": 839.4,
        "transcript": "Yuum piqangraakut kiularavkenaki.",
        "translation": "Though a person does anything to us, we shouldn't retort."
    },
    "129": {
        "startTime": 839.75,
        "endTime": 847.22,
        "transcript": "Anagyaaqeksaunata-llu, assiryukeksaunata-llu.",
        "translation": "And we shouldn't defend ourselves, and not think that we're good people."
    },
    "130": {
        "startTime": 847.58,
        "endTime": 854.45,
        "transcript": "Maani-llu tarrartellemteńi ilamteńi-llu assinruyukluta piqaqsaunata",
        "translation": "And as we walk here, we should never think we're better than those around us"
    },
    "131": {
        "startTime": 854.45,
        "endTime": 860.46,
        "transcript": "Tau͡gaam assiilucirput wangkuta umyuaqaqluku.",
        "translation": "But remember our own faults."
    },
    "132": {
        "startTime": 860.46,
        "endTime": 867.19,
        "transcript": "Tau͡gaam-llu assiilucirput umyuaqaqluku",
        "translation": "But also, we should remember our own faults"
    },
    "133": {
        "startTime": 867.19,
        "endTime": 877.37,
        "transcript": "Ilaliurturalput-llu taqsuunaki wangkuta assiitellerput pivkenaku.",
        "translation": "And do not stop interacting with people because of our faults."
    },
    "134": {
        "startTime": 879.23,
        "endTime": 884.34,
        "transcript": "Ilaliuqcaarluki tau͡gaam yuut yuunaqliniluta.",
        "translation": "Evidently, we must live socializing with other people."
    },
    "135": {
        "startTime": 884.84,
        "endTime": 891.79,
        "transcript": "Tuamtell' cali waten call' qanrucimalallruukuk:",
        "translation": "Then we would also be told this:"
    },
    "136": {
        "startTime": 893.19,
        "endTime": 898.0,
        "transcript": "Atam-gguq an'aqamegnuk",
        "translation": "They said that when we go out"
    },
    "137": {
        "startTime": 898.33,
        "endTime": 904.01,
        "transcript": "Egmianun-gguq ankumegnuk ellam qukaa tangerqilauk.",
        "translation": "They said that right when we go out, we should look in the middle of the [Spirit of the] Universe."
    },
    "138": {
        "startTime": 904.9,
        "endTime": 908.86,
        "transcript": "Ellam-gguq Yua elingratartuq.",
        "translation": "They said that the Spirit of the Universe is grateful by nature."
    },
    "139": {
        "startTime": 909.39,
        "endTime": 919.56,
        "transcript": "Ella-gguq paqnakerrlainarluku, kiarterrlainarluku, tamakut-llu agyat cuqyutet, cuqyutait.",
        "translation": "They said to always check the weather, always look around, including at the navigation stars."
    },
    "140": {
        "startTime": 919.56,
        "endTime": 924.64,
        "transcript": "Tuamtell' call' akerta sass'aqellruluku yuut.",
        "translation": "Then people also used the sun to measure time."
    },
    "141": {
        "startTime": 924.64,
        "endTime": 933.51,
        "transcript": "Tamaa-i-llu wani sass'anek makunek wani atulangllemni",
        "translation": "And back when I started using these clocks"
    },
    "142": {
        "startTime": 933.74,
        "endTime": 938.91,
        "transcript": "Aataka atam sass'anek piyuitellruuq, akertekun tau͡gaam.",
        "translation": "My father, you see, never used clocks, only the sun."
    },
    "143": {
        "startTime": 938.91,
        "endTime": 945.84,
        "transcript": "Tua-i wani ellamek-ll' itraarluni, anrraarluni itraqami qanlallruuq",
        "translation": "Then after coming in from outside, after he went out and came in, he would say"
    },
    "144": {
        "startTime": 945.84,
        "endTime": 949.22,
        "transcript": "\"Erneq-gguq qukartuq. Nernariuq-gguq.\"",
        "translation": "\"It's noon. It's time to eat.\""
    },
    "145": {
        "startTime": 949.22,
        "endTime": 954.94,
        "transcript": "Maaten tang sass'aqa pinaurqa qukarluni, amta-ll' sass'amek tangerqengaunani.",
        "translation": "I would look at my clock and find that it was noon, yet he never saw a clock."
    },
    "146": {
        "startTime": 954.94,
        "endTime": 965.71,
        "transcript": "Tuamtell' caaqami akerta pugqe'rcan egalernun qanernaurtuq, \"One kela'agtuq-gguq.\"",
        "translation": "Then sometimes, when the sun appeared in the windows, he would say, \"It's one o'clock.\""
    },
    "147": {
        "startTime": 965.71,
        "endTime": 969.36,
        "transcript": "Maaten cali sass'aqa tangerrnaurqa one kela'agluni.",
        "translation": "I would look at my clock and find it would be one o'clock."
    },
    "148": {
        "startTime": 969.36,
        "endTime": 976.61,
        "transcript": "Tua-i cali sassauyugngalliniluni pekqurallrakun maaggun tangvagluku.",
        "translation": "It can also be used to measure time by watching how it moves."
    },
    "149": {
        "startTime": 980.11,
        "endTime": 986.76,
        "transcript": "Ellaitni nallunaunani, wangkutni nallunaqluni tamana.",
        "translation": "That is clear to them, and confusing for us."
    },
    "150": {
        "startTime": 990.45,
        "endTime": 998.78,
        "transcript": "Nallunaqngalengraata murilkellriit tamakut tuaten pitulliniut.",
        "translation": "Though thye seem confusing, those who are observant do that."
    },
    "151": {
        "startTime": 998.78,
        "endTime": 1006.93,
        "transcript": "Ava-i-am au͡gna-llu uumi tauna icivaq niitellemni, niigartellemni au͡gna",
        "translation": "When I recently heard that, when I heard that"
    },
    "152": {
        "startTime": 1006.93,
        "endTime": 1011.74,
        "transcript": "Eneqaqaqeka au͡gna cali waten qanrucimalalqa",
        "translation": "I remember how I was told this"
    },
    "153": {
        "startTime": 1011.74,
        "endTime": 1015.44,
        "transcript": "Yuk pillerkaa.",
        "translation": "About what a person should do."
    },
    "154": {
        "startTime": 1015.44,
        "endTime": 1019.41,
        "transcript": "Tuamtell' cali qanrut'lallrulua",
        "translation": "Then they also used to tell me"
    },
    "155": {
        "startTime": 1019.77,
        "endTime": 1027.11,
        "transcript": "Makut-wa kasngunarqengraata, takarnarqengraata qanrutkumaarkaulriit.",
        "translation": "Though these are shameful and embarrassing, they must be told."
    },
    "156": {
        "startTime": 1027.11,
        "endTime": 1029.84,
        "transcript": "Atam qanrutkumaarkaullinilriit.",
        "translation": "You see, they must be told."
    },
    "157": {
        "startTime": 1029.84,
        "endTime": 1038.24,
        "transcript": "Tuamtell' cali kasngunaqpiangraata qalarutetulliniluku.",
        "translation": "Then they would also speak to them though they were very shameful [topics]."
    },
    "158": {
        "startTime": 1038.24,
        "endTime": 1041.67,
        "transcript": "Tuamtell' qanrut'lallruatnga",
        "translation": "Then they used to tell me"
    },
    "159": {
        "startTime": 1052.36,
        "endTime": 1056.29,
        "transcript": "Nalluyaguartaqa-am qanerkaqa wani.",
        "translation": "I forgot what I was going to say."
    },
    "160": {
        "startTime": 1056.29,
        "endTime": 1062.51,
        "transcript": "Iciw' cakviussiyaallemni",
        "translation": "You know, when I had too hard of a time"
    },
    "161": {
        "startTime": 1062.69,
        "endTime": 1070.72,
        "transcript": "Cakviussiyaallma kinguani wani waten iliini qanerkanka, pitsaqenritua, nalluyagutelaranka.",
        "translation": "After I struggled too much, I apologize, I sometimes forget what I'm going to say."
    },
    "162": {
        "startTime": 1070.8,
        "endTime": 1076.12,
        "transcript": "Tau͡gaam-llu waten umyuaminek-llu ping'e'rmi",
        "translation": "But also, though one struggles with mental health"
    },
    "163": {
        "startTime": 1076.12,
        "endTime": 1081.73,
        "transcript": "Yuut waten yuut umyuaminek ping'e'rmi",
        "translation": "Though people struggle with mental health"
    },
    "164": {
        "startTime": 1083.05,
        "endTime": 1087.7,
        "transcript": "Pinarqut, umyuaqnarqut wani.",
        "translation": "We must remember them."
    },
    "165": {
        "startTime": 1087.7,
        "endTime": 1093.71,
        "transcript": "Ava-i qanelrianga, ava-i qalarcaaqellrianga au͡g'umek qanqatarlua nalluyagutaqa",
        "translation": "I just said, I was just speaking about to say that, and I forgot"
    },
    "166": {
        "startTime": 1093.71,
        "endTime": 1103.26,
        "transcript": "Tuani cakviurpapiallemni, ilarrlainaqellruamki-llu taukut uksuq imumi arulaillret week-am iluani.",
        "translation": "When I struggled a lot, since they were all my relatives who passed away last winter over the course of one week."
    },
    "167": {
        "startTime": 1103.26,
        "endTime": 1107.65,
        "transcript": "Tau͡gaam kitak' umyuarteq'lalta",
        "translation": "But let us have this mindset"
    },
    "168": {
        "startTime": 1108.16,
        "endTime": 1112.91,
        "transcript": "Cakviungramta yuut tamarmeng aturaat.",
        "translation": "Though we struggle, all people experience it."
    },
    "169": {
        "startTime": 1112.91,
        "endTime": 1115.79,
        "transcript": "Aturaat yuut tamarmeng.",
        "translation": "All people experience it."
    },
    "170": {
        "startTime": 1118.38,
        "endTime": 1126.14,
        "transcript": "Yuk-llu kiimi piyukevkenani, yuut tamarmeng cakviutulliniut umyuameggnek",
        "translation": "And a person shouldn't think they're the only one, since all people struggle with mental health"
    },
    "171": {
        "startTime": 1126.14,
        "endTime": 1130.91,
        "transcript": "Iliini wani cakneq cakviuraqluteng.",
        "translation": "Sometimes having great troubles."
    },
    "172": {
        "startTime": 1131.0,
        "endTime": 1138.67,
        "transcript": "Tua-i cali qanrutkumalallret, qanlallret waten:",
        "translation": "Also, this was said, people said this:"
    },
    "173": {
        "startTime": 1141.79,
        "endTime": 1150.27,
        "transcript": "Yuk-gguq ellminek piyukellria umyuiqetuuq, kiituani-gguq usvillugtuq.",
        "translation": "They said that one who thinks they're alone become severely depressed, until eventually they go insane."
    },
    "174": {
        "startTime": 1150.98,
        "endTime": 1158.89,
        "transcript": "Tua-i-gguq-wa waten umyuarteqngami: \"Wiinga kiima nangtequa umyuamnek.\"",
        "translation": "They said it's because he thinks like this: \"I am the only one struggles with mental health.\""
    },
    "175": {
        "startTime": 1158.89,
        "endTime": 1165.42,
        "transcript": "Tau͡gken ellam iluani yuut tamarmeng nangteqtuluteng maani.",
        "translation": "However, all people in the world suffer here."
    },
    "176": {
        "startTime": 1166.25,
        "endTime": 1175.25,
        "transcript": "Taumek wani waten pivkenata, umyuamteńek kiimeta nangteqsukevkenata.",
        "translation": "That's why we should think that we're the only ones struggling with mental health."
    },
    "177": {
        "startTime": 1175.7,
        "endTime": 1187.8,
        "transcript": "Tau͡gaam umyuaqaqluki allat-llu nangteqellriit, tau͡gaam-llu pray-autaqluki wangkucicetun nangtequrlurmilriit umyuameggnek.",
        "translation": "Instead, we should remember others with mental health problems, but pray for the ones who are also struggling with mental health like us."
    },
    "178": {
        "startTime": 1188.6,
        "endTime": 1196.47,
        "transcript": "Maa-i wani cakneq erenret ilaitni cakviurnaqluni erneq tekitelartuq.",
        "translation": "Now, some days, a day comes where it is very hard."
    },
    "179": {
        "startTime": 1196.47,
        "endTime": 1202.18,
        "transcript": "Elpeci ap'lararci umyuarpeceńek hard time-arniluci.",
        "translation": "You call it, having a hard time with your mental health."
    },
    "180": {
        "startTime": 1202.18,
        "endTime": 1205.67,
        "transcript": "Tua-i tamaa-i-nguuq tamana.",
        "translation": "That's what that is."
    },
    "181": {
        "startTime": 1206.44,
        "endTime": 1211.02,
        "transcript": "Kitak' kiimeta umyuarteqsukeksaunata.",
        "translation": "Now, let's not think we're the only ones who think that."
    },
    "182": {
        "startTime": 1211.02,
        "endTime": 1216.66,
        "transcript": "Instead, let all of us people consider each other",
        "translation": "Instead, let all of us people consider each other"
    },
    "183": {
        "startTime": 1216.66,
        "endTime": 1219.75,
        "transcript": "Pray-akun-llu umyuaqutaqluta piniartukut.",
        "translation": "And let us consider each other in prayer."
    },
    "184": {
        "startTime": 1220.94,
        "endTime": 1223.22,
        "transcript": "Tua-i waten pitalii.",
        "translation": "This is all from me."
    },
    "185": {
        "startTime": 1236.13,
        "endTime": 1241.16,
        "transcript": "Tuaten [?].",
        "translation": "Like that [?]."
    },
    "186": {
        "startTime": 1248.85,
        "endTime": 1251.8,
        "transcript": "Qaillun-wa qanerkailama",
        "translation": "Since I have nothing to say"
    },
    "187": {
        "startTime": 1251.8,
        "endTime": 1256.29,
        "transcript": "Kiingan qanerkaqngamku qalartellrianga au͡g'umek.",
        "translation": "Since it was all I had to say, I talked about that."
    },
    "188": {
        "startTime": 1295.04,
        "endTime": 1297.51,
        "transcript": "Qanra. Qanra.",
        "translation": "Its mouth. Its mouth."
    },
    "189": {
        "startTime": 1302.73,
        "endTime": 1309.19,
        "transcript": "Aling kingu'urrluku camera-liurteńgurtellriaten qimugteḿek.",
        "translation": "Oh my, you're late and ended up fixing the camera for the dog."
    }
};